import { use } from 'react';

import { AuthContext } from './context';

export const useAuth = () => {
  const context = use(AuthContext);

  if (!context) {
    throw new Error('AuthContext is undefined');
  }

  return context;
};
